import React from 'react';
import OverviewLogic from './OverviewLogic';
/**
 * Display for Overview components.
 * @return {Overview}
 */
function OverviewPage() {
  return (
    <div className='centerScreen'>
      <div className='centerPart'>
        <OverviewLogic/>
      </div>
    </div>
  );
}

export default OverviewPage;
